import { Backdrop, Box, CircularProgress } from "@mui/material";
import { useState } from "react";

export const LoaderMUI = ({ withBackdrop = false, size = 40 }) => {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return withBackdrop ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: 2, background: "#dbdbeb8f" }}
      open={open}
      onClick={handleClose}
    >
      <CircularProgress size={size} />
    </Backdrop>
  ) : (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
